import React from 'react';
import Icon from '../../../components/AppIcon';

const WeatherWidget = ({ weather }) => {
  const getConditionIcon = (condition) => {
    const icons = {
      'sunny': 'Sun',
      'cloudy': 'Cloud',
      'rainy': 'CloudRain',
      'stormy': 'CloudLightning'
    };
    return icons?.[condition] || 'Cloud';
  };

  const getConditionColor = (condition) => {
    const colors = {
      'sunny': 'text-warning',
      'cloudy': 'text-muted-foreground',
      'rainy': 'text-info',
      'stormy': 'text-error'
    };
    return colors?.[condition] || 'text-muted-foreground';
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-conservation">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Current Weather</h3>
        <Icon name={getConditionIcon(weather?.condition)} size={32} className={getConditionColor(weather?.condition)} />
      </div>
      
      <div className="grid grid-cols-2 gap-4 mb-6">
        <div>
          <p className="text-3xl font-bold text-gray-900 dark:text-white">{weather?.temperature}°C</p>
          <p className="text-sm text-gray-500 dark:text-gray-400 capitalize">{weather?.condition}</p>
        </div>
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-sm">
            <Icon name="Droplet" size={16} className="text-info" />
            <span className="text-gray-600 dark:text-gray-300">{weather?.humidity}% Humidity</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Icon name="Wind" size={16} className="text-muted-foreground" />
            <span className="text-gray-600 dark:text-gray-300">{weather?.windSpeed} km/h</span>
          </div>
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-4 pt-4 border-t border-border">
        <div>
          <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">Visibility</p>
          <p className="text-sm font-medium text-gray-900 dark:text-white">{weather?.visibility} km</p>
        </div>
        <div>
          <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">Pressure</p>
          <p className="text-sm font-medium text-gray-900 dark:text-white">{weather?.pressure} hPa</p>
        </div>
      </div>
      
      {weather?.alerts && weather?.alerts?.length > 0 && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-center gap-2 text-error">
            <Icon name="AlertTriangle" size={16} />
            <span className="text-sm font-medium">Active Weather Alerts</span>
          </div>
          <ul className="mt-2 space-y-1">
            {weather?.alerts?.map((alert, index) => (
              <li key={index} className="text-sm text-gray-600 dark:text-gray-300 flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-error rounded-full"></span>
                {alert}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default WeatherWidget;